'use client';

import { useCallback } from 'react';
import { caseHref, type CaseAddress } from '../lib/caseHref';
import { useRuntime } from '../runtime/RuntimeContext';
import { useLocalizedHref } from './useLocalizedHref';

// WHY: в Mini App адресов нет — Next-ссылка увела бы WebView на корень, там карточка остаётся кнопкой стека
export function useCaseLinkHref(): (caseItem: CaseAddress) => string | undefined {
  const runtime = useRuntime();
  const localize = useLocalizedHref();
  return useCallback(
    (caseItem: CaseAddress) => (runtime === 'web' ? localize(caseHref(caseItem)) : undefined),
    [runtime, localize],
  );
}
